import React from 'react';
import { Ticker, TickerLink } from '@benzinga/ticker-ui';
import { CoveyAnalystPortfolio } from './CoveyAnalystTable';

export const CoveyAnalystMetricsColumnsDef = [
  {
    cellRenderer: ({ index }: { index: number }) => {
      return <span>{index + 1}.</span>;
    },
    colSpan: 1,
    field: 'index',
    headerName: '',
    shouldRender: true,
  },
  {
    cellRenderer: ({ data }: { data: CoveyAnalystPortfolio }) => {
      return (
        <Ticker
          slug="analyst-ratings"
          symbol={data.symbol}
          targetElement={<TickerLink symbol={data.symbol}>{data.symbol}</TickerLink>}
        />
      );
    },
    colSpan: 2,
    field: 'symbol',
    headerName: 'Ticker',
  },
  {
    cellClass: 'semibold',
    colSpan: 1,
    field: 'percent',
    headerName: 'Percent',
    valueFormatter: ({ data }: { data: CoveyAnalystPortfolio }) => {
      return data.percent ? `${data.percent.toFixed(2)}%` : '—';
    },
  },
];

export default CoveyAnalystMetricsColumnsDef;
